export default __webpack_public_path__ + "static/media/051-parabolic.a3d06fbe.svg";